import cn from '@/lib/clsxm';

import { SIZE_ENUM } from '@/components/@base/@helpers/types';
import Container from '@/components/@base/container';
import { Heading, Text } from '@/components/@base/typography';
import { HEADING_TYPE } from '@/components/@base/typography/heading/type';
import { TEXT_TYPE } from '@/components/@base/typography/text/type';
import XImage from '@/components/@base/x-image';

import { DATA_CY_BEST_SELLER_NAME } from '@/constant/cypress';
import StoreModel from '@/models/store.model';
import DOMPurify from 'isomorphic-dompurify';

type IntroHeaderProps = Pick<StoreModel, 'name' | 'description' | 'logo'>;

export default function IntroHeader({ name, description, logo }: IntroHeaderProps) {
  const descriptionContent = DOMPurify.sanitize(description);

  return (
    <Container>
      <Container className='mb-3 flex flex-row items-center gap-4 lg:mb-4 '>
        <XImage
          className={cn('rounded-full border-2 border-white')}
          alt={logo.title}
          width={55}
          height={55}
          src={logo.publicLink}
        />
        <Heading
          data-cy={DATA_CY_BEST_SELLER_NAME}
          type={HEADING_TYPE.H2}
          className='text-[17px] font-bold leading-9 tracking-tighter text-[#404040]'
        >
          {name}
        </Heading>
      </Container>
      <Text
        type={TEXT_TYPE.P}
        size={SIZE_ENUM.MD}
        className='font-light text-[15px] leading-7 tracking-tighter text-[#424244]'
        dangerouslySetInnerHTML={{ __html: descriptionContent }}
      />
    </Container>
  );
}
